import { createFileRoute, redirect } from "@tanstack/react-router";
export const Route = createFileRoute("/diy-foam-roofing.html")({
  beforeLoad: () => { throw redirect({ to: "/foam-roof-repair-phoenix", statusCode: 301 }); },
});
